module.exports = __webpack_public_path__ + "img/icon-arrow-right-small.fed6e594.svg";